module.exports = __webpack_public_path__ + "jm.2fbfcbf1.svg";